import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ScrollText, User, Bot } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHeader, EmptyState, Card } from "@/components/common";
import { formatDate, relativeTime } from "@/lib/format";

export default function Audit() {
  const { companyParam, companyId } = useApp();
  const { data: items = [], isLoading } = useQuery({
    queryKey: ["activity", companyId],
    queryFn: async () => (await api.get("/activity", { params: companyParam })).data,
  });

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Trail" subtitle="Full audit of directives, outputs, approvals and file usage. Every action is logged for evidence-backed autonomy." />
      {isLoading ? <div className="text-sm text-ink-muted">Loading…</div> : items.length === 0 ? (
        <EmptyState icon={ScrollText} title="No activity recorded" />
      ) : (
        <Card>
          <div className="divide-y divide-border">
            {items.map((a) => (
              <div key={a.id} className="flex items-start gap-3 px-4 py-3" data-testid={`audit-row-${a.id}`}>
                <div className={`w-7 h-7 flex items-center justify-center shrink-0 ${a.actor_type === "user" ? "bg-brand text-white" : "bg-ink text-white"}`}>
                  {a.actor_type === "user" ? <User className="w-3.5 h-3.5" /> : <Bot className="w-3.5 h-3.5" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-ink">{a.summary}</div>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-[11px] font-semibold text-ink-muted">{a.actor}</span>
                    <span className="font-mono text-[10px] text-ink-faint uppercase tracking-wider bg-surface-muted px-1.5 py-0.5">{a.action}</span>
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <div className="font-mono text-[11px] text-ink-faint">{relativeTime(a.created_at)}</div>
                  <div className="font-mono text-[10px] text-ink-faint">{formatDate(a.created_at, { hour: "2-digit", minute: "2-digit" })}</div>
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
}
